import React, { useEffect, useState } from 'react'
import Sidebar from './sidebarstudent'
import Header from './Headerstudent'
import { FaUserLarge } from 'react-icons/fa6'
import { Link, useNavigate } from 'react-router-dom'
import { MdEvent } from 'react-icons/md'
import { Button } from '@mui/material'
import { EventDashboardApi, StudentInstallmentPayApi } from '../../ApiFile'
import { Pie } from 'react-chartjs-2'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { StudentMessTodaysMenuFindall } from '../../ApiFile'
import { Col, Row } from 'react-bootstrap'
import axios from 'axios'
import { toast } from 'react-toastify'
import { FaUtensils } from 'react-icons/fa'
import MobileNavbar from './MobileNavbar'

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels)

const Homestudent = () => {
  const [error, setError] = useState(null)
  const [events, setEvents] = useState([])
  const [lunchData, setLunchData] = useState(null)
  const [dinnerData, setDinnerData] = useState(null)

  const year = sessionStorage.getItem('year')
  const memberId = sessionStorage.getItem('member_id')
  const [data, setData] = useState([])
  const navigate = useNavigate()

  //  useEffect(() => {
  //     const fetchInstallmentData = async () => {
  //       try {
  //         const response = await fetch(StudentInstallmentPayApi, {
  //           method: 'POST',
  //           headers: {
  //             'Content-Type': 'application/json',
  //           },
  //           body: JSON.stringify({ member_id: memberId,year:year }),
  //         })
  
  //         if (!response.ok) {
  //           throw new Error('Network response was not ok')
  //         }

  
  //         const jsonData = await response.json()
  //         if (jsonData == 'Already payment done') {
  //           setData("Already payment done") // Reset data if NOTFOUND        
  //         }else if(jsonData == 'Approval pending'){
  //            setData("Approval pending") 
  //         } else {
  //           setData(jsonData)
  //         }
  //         setError(null)
  //       } catch (error) {
  //         // console.error('Error fetching data:', error);
  //         setError(error.message)
  //       } finally {
  //         // setLoading(false)
  //       }
  //     }
  
  //     fetchInstallmentData()
  //   }, [memberId])

  useEffect(() => {
  const fetchInstallmentData = async () => {
    try {
      const response = await axios.post(StudentInstallmentPayApi, {
        member_id: memberId,
        year: year,
      });

      if (response.data == "NOTFOUND") {
        // toast.warn("DATA Not Found")
        return;
      }

      const jsonData = response.data;
      
      if (jsonData === 'Already payment done') {
        setData('Already payment done');
      } else if (jsonData === 'Approval pending') {
        setData('Approval pending');
      } else {
        setData(jsonData);
      }

      setError(null);
    } catch (error) {
      setError(error.message);
    } finally {
      // Optionally handle loading state here
    }
  };

  fetchInstallmentData();
}, [memberId]);


  useEffect(() => {
    //----------------------------Disabled back button-------------------------------
    window.history.pushState(null, null, window.location.href)

    const handleBackButton = (event) => {
      event.preventDefault()
      window.history.forward()
    }

    window.addEventListener('popstate', handleBackButton)

    return () => {
      window.removeEventListener('popstate', handleBackButton)
    }
  }, [])

  // useEffect(() => {
  //   fetch(EventDashboardApi)
  //     .then((response) => {
  //       if (!response.ok) {
  //         throw new Error('NOTFOUND')
  //       }
  //       return response.json()
  //     })
  //     .then((response) => {
  //       setEvents(response)
  //     })
  //     .catch((error) => {
  //       if (error.message === 'NOTFOUND') {
  //         console.log('Resource not found')
  //       } 
  //     })
  // }, [EventDashboardApi])

  useEffect(() => {
  axios.get(EventDashboardApi)
    .then((response) => {
      if (response.data == "NOTFOUND") {
        toast.warn("Event Data Notfound")
      }
      else if(response.data !== null){
        setEvents(response.data);
      }
    })
    .catch((error) => {
      if (error.response && error.response.status === 404) {
        console.log('Resource not found');
      } else {
        console.log('Error fetching data:', error);
      }
    });
}, [EventDashboardApi]);

  useEffect(() => {
    // Fetch the today's menu data from the API
    fetch(StudentMessTodaysMenuFindall)
      .then((response) => response.json())
      .then((data) => {
        // Update the lunch data
        setLunchData({
          labels: data.lunch.map((item) => item.menu),
          datasets: [
            {
              data: data.lunch.map(() => 15), // Example data values, modify as needed
              backgroundColor: [
                '#FF6384',
                '#36A2EB',
                '#FFCE56',
                '#4BC0C0',
                '#9966FF',
                '#FF9F40',
                '#FFCD56',
              ],
              color:"black",
            },
          ],
        })

        // Update the dinner data
        setDinnerData({
          labels: data.dinner.map((item) => item.menu),
          datasets: [
            {
              data: data.dinner.map(() => 20), // Example data values, modify as needed
              backgroundColor: [
                '#FF6384',
                '#36A2EB',
                '#FFCE56',
                '#4BC0C0',
                '#9966FF',
                '#FF9F40',
              ],
              color:"black",
            },
          ],
        })
      })
      .catch((error) => {
        console.error('Error fetching the menu data:', error)
      })
  }, [])

    const handlePay = () => {
    navigate('/InstallmentPay')
  }
  // Chart options with datalabels plugin
  const options = {
    responsive: true,
    maintainAspectRatio: false, // Allows chart to resize better
    plugins: {
      legend: {
        display: false, // Hide the legend since labels will be on the chart
      },
      datalabels: {
        color: '#000', // Text color for the labels
        formatter: (value, context) => {
          return context.chart.data.labels[context.dataIndex]
        },
        font: {
          weight: 'bold',
        },
      },
    },
  }

  return (
    <>

     <div className="roomchange-container" style={{ display: 'flex', minHeight: '100vh' }}>
      {/* Sidebar on the left for desktop */}
      <div className="d-none d-md-block sidebar-container" style={{ width: '270px', flexShrink: 0, }}>
        <Sidebar />
      </div>

      {/* Main content on the right */}
      <div className="main-content flex-grow-1" style={{ flex: 1, backgroundColor: '#f8f9fa'}}>
        <Header />
     
           <div className="d-block d-md-none">
             <MobileNavbar />
           </div>

        <div className="border w-100 h-100 py-3" style={{backgroundColor:"#f5f5f5ff"}}>
          <div className="row m-0 block-header ps-3">
            <h5 className="room-change-title text-start mt-md-4 mt-2" style={{ color: '#0783d6' }}>
              Dashboard
            </h5>
          </div>

        <div className="row mx-1">
          <div className="col-12 col-md-3 p-2 ">
            <div
              className="p-2 rounded"
              style={{
                backgroundColor: '#fff',
                border: 'none',
                color: '#2bdbd1',
                borderBottom: '5px solid rgb(247, 140, 177)',
              }}
            >
              <div className="row p-0 m-0">
                <div className="col-12 d-flex fs-5 pt-2">
                  <FaUserLarge style={{ color: 'gray' }} />
                  &nbsp;&nbsp;&nbsp;
                  <h5>Profile</h5>
                </div>
                <div
                  className="col-12 ps-5 "
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <div className="fs-5" style={{ color: 'gray' }}></div>
                  <div>
                    <Button>
                      <Link to="/StudentProfile" className="navigateLink">
                        <Button
                          style={{
                            backgroundColor: 'rgb(247, 140, 177)',
                            color: 'black',
                          }}
                        >
                          View
                        </Button>
                      </Link>
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-3 p-2 ">
            <div
              className="p-2 rounded"
              style={{
                backgroundColor: '#fff',
                border: 'none',
                color: '#2bdbd1',
                borderBottom: '5px solid #2bdbd1',
              }}
            >
              <div className="row p-0 m-0">
                <div className="col-12 d-flex fs-5 pt-2">
                  <FaUserLarge style={{ color: 'gray' }} />
                  &nbsp;&nbsp;&nbsp;
                  <h5>Attendance Mess</h5>
                </div>
                <div
                  className="col-12 ps-5 "
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <div className="fs-5" style={{ color: 'gray' }}></div>
                  <div>
                    <Button>
                      <Link to="/MessAttendance" className="navigateLink">
                        <Button
                          style={{ backgroundColor: '#2bdbd1', color: 'black' }}
                        >
                          View
                        </Button>
                      </Link>
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-3 p-2 ">
            <div
              className="p-2 rounded"
              style={{
                backgroundColor: '#fff',
                border: 'none',
                color: '#2bdbd1',
                borderBottom: '5px solid orange',
              }}
            >
              <div className="row p-0 m-0">
                <div className="col-12 d-flex fs-5 pt-2">
                  <FaUserLarge style={{ color: 'gray' }} />
                  &nbsp;&nbsp;&nbsp;
                  <h5>Attendance Event</h5>
                </div>
                <div
                  className="col-12 ps-5 "
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <div className="fs-5" style={{ color: 'gray' }}></div>
                  <div>
                    <Button>
                      <Link to="/MyAttendance" className="navigateLink">
                        <Button
                          style={{ backgroundColor: 'orange', color: 'black' }}
                        >
                          View
                        </Button>
                      </Link>
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-3 p-2 ">
            <div
              className="p-2 rounded"
              style={{
                backgroundColor: '#fff',
                border: 'none',
                color: '#2bdbd1',
                borderBottom: '5px solid rgb(57, 158, 161',
              }}
            >
              <div className="row p-0 m-0">
                <div className="col-12 d-flex fs-5 pt-2">
                  <FaUserLarge style={{ color: 'gray' }} />
                  &nbsp;&nbsp;&nbsp;
                  <h5>Jobs</h5>
                </div>
                <div
                  className="col-12 ps-5 "
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <div className="fs-5" style={{ color: 'gray' }}></div>
                  <div>
                    <Button>
                      <Link to="/Jobsstudent" className="navigateLink">
                        <Button
                          style={{
                            backgroundColor: 'rgb(57, 158, 161)',
                            color: 'black',
                          }}
                        >
                          View
                        </Button>
                      </Link>
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row mx-1 d-flex">
          <div className="col-12 col-md-4 p-2 mb-lg-5 pb-lg-5 mb-md-1 pb-md-1">
            <div
              className="p-2 rounded"
              style={{
                backgroundColor: '#fff',
                border: 'none',
                height: '250px',
                color: '#2bdbd1',
                borderBottom: '5px solid rgb(146, 209, 83)',
              }}
            >
              <div className="row p-0 m-0 ">
                <div
                  className="col-12 d-flex fs-5 pt-2"
                  style={{ borderBottom: '1px solid gray' }}
                >
                  <MdEvent style={{ color: 'gray' }} />
                  &nbsp;&nbsp;&nbsp;
                  <h5>Upcoming Events</h5>
                </div>
                <div
                  className="col-12"
                  style={{ overflowY: 'scroll', maxHeight: '148px' }}
                >
                  {error ? (
                    <div>{error}</div>
                  ) : (
                    <table className="table">
                      <thead>
                        <tr
                          className="p-0 m-0"
                          style={{ height: '10px', fontSize: '13px' }}
                        >
                          <th scope="col">Sr No</th>
                          <th scope="col">Event Date</th>
                          <th scope="col">Description</th>
                        </tr>
                      </thead>
                      <tbody>
                        {events.map((event, index) => (
                          <tr
                            key={index}
                            style={{ height: '15px', fontSize: '13px' }}
                          >
                            <td>{index + 1}</td>
                            <td>{event.event_date}</td>
                            <td>{event.description}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-4 p-2 mb-lg-5 pb-lg-5 mb-md-1 pb-md-1">
            <div
              className="p-2 rounded"
              style={{
                backgroundColor: '#fff',
                border: 'none',
                // height: '250px',
                color: '#2bdbd1',
                borderBottom: '5px solid rgb(146, 209, 83)',
              }}
            >
              <div className="row p-0 m-0 ">
                <div
                  className="col-12 d-flex fs-5 pt-2"
                  style={{ borderBottom: '1px solid gray' }}
                >
                  <MdEvent style={{ color: 'gray' }} />
                  &nbsp;&nbsp;&nbsp;
                  <h5>Todays Mess Menu</h5>
                </div>
                <div
                  className="col-12"
                  style={{ overflowY: 'scroll', }}
                >
                  <Row
                    style={{ display: 'flex', justifyContent: 'space-evenly' }}
                  >
                    <Col xs={12} md={6} className="text-center" style={{borderRight:"1px solid black"}}>
                      <h4>Lunch</h4>
                        {lunchData && (
                            <Row className="mt-3 justify-content-center">
                              {lunchData.labels.map((menuItem, index) => (
                                <Col xs={6} key={index} className="mb-2">
                                  <div
                                    className="d-flex align-items-center justify-content-center"
                                    style={{
                                      backgroundColor: '#ffea8bff',
                                      padding: '6px',
                                      borderRadius: '10px',
                                      boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                                      color:"black",
                                    }}
                                  >
                                    {/* <FaUtensils style={{ color: 'green', marginRight: '6px' }} /> */}
                                    <span style={{ whiteSpace: 'nowrap' }}>{menuItem}</span>
                                  </div>
                                </Col>
                              ))}
                            </Row>
                          )}                      
                    </Col>

                    <Col xs={12} md={6} className="text-center" >
                      <h4>Dinner</h4>
                        {dinnerData && (
                          <Row className="mt-3 justify-content-center">
                            {dinnerData.labels.map((menuItem, index) => (
                              <Col xs={6} key={index} className="mb-2">
                                <div
                                  className="d-flex align-items-center justify-content-center"
                                  style={{
                                    backgroundColor: '#aef3ffff',
                                    padding: '6px',
                                    borderRadius: '10px',
                                    boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                                    color:"black",
                                  }}
                                >
                                  {/* <FaUtensils style={{ color: 'blue', marginRight: '6px' }} /> */}
                                  <span style={{ whiteSpace: 'nowrap' }}>{menuItem}</span>
                                </div>
                              </Col>
                            ))}
                          </Row>
                        )}
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>


           <div className="col-12 col-md-4 p-2 mb-lg-5 pb-5 mb-md-1 pb-md-1">
            <div
              className="p-2 rounded"
              style={{
                backgroundColor: '#fff',
                border: 'none',
                height: '250px',
                color: '#2bdbd1',
                borderBottom: '5px solid rgb(146, 209, 83)',
              }}
            >
              <div className="row p-0 m-0 ">
                <div
                  className="col-12 d-flex fs-5 pt-2"
                  style={{ borderBottom: '1px solid gray' }}
                >
                  <MdEvent style={{ color: 'gray' }} />
                  &nbsp;&nbsp;&nbsp;
                  <h5>Amount Pending</h5>
                </div>
                <div
                  className="col-12"
                  style={{ overflowY: 'scroll',  }}
                >
                  <Row
                    style={{ display: 'flex', justifyContent: 'space-evenly' }}
                  >

                    {data && data !== 'Already payment done' ? (
                      <div>
                            {data.map((payment) => (
                              <div key={payment.block_id}>
                                <h2 className="main-title1 blink">Amount Pending</h2>

                                <p className="ps-3">
                                  <strong style={{color:"red"}}>Rs:</strong> <span style={{color:"red"}}>{payment.receive_amount}</span> <br />
                                  <strong style={{color:"red"}}>Due Date:</strong> <span style={{color:"red"}}>{payment.installment_date}</span>
                                </p>

                                {Number(payment.receive_amount) === 0 ? (
                                  <p>Payment is fully done.</p>
                                ) : (
                                  <div className="text-center">
                                    <Button
                                      variant="contained"
                                      color="primary"
                                      onClick={handlePay}
                                    >
                                      Pay
                                    </Button>
                                  </div>
                                )}
                              </div>
                            ))}
                          </div>
                       
                      ) : (
                          <span>Payment Done</span> 
                      )}

                  </Row>
                </div>
              </div>
            </div>
          </div>



        </div>
        
      </div>
      </div>
      </div>
    </>
  )
}

export default Homestudent
